<template>
  <QmulusButton
    presentation="inline"
    :loading="notificationStore.notificationUnreadCountIsLoading"
    type="button"
    label=""
    :icon="!notificationStore.notificationUnreadCount ? 'pi pi-bell' : NotificationUnreadIcon"
    @click="overlayPanel!.toggle($event);"
  />
  <PrmOverlayPanel
    ref="overlayPanel"
    style="width: 38rem;"
    :pt="{
      content: {
        style: 'padding: 0;',
      },
    }"
  >
    <div
      style="gap: 0;"
      class="flex-column"
    >
      <div
        style="background-color: var(--surface-1); height: 5rem; padding: var(--gap); gap: 0;"
        class="flex-row justify-spaced align-center w-full"
      >
        <div style="font-weight: bold;">
          <span>
            {{ i18n.global.t('common.notification', 2) }}
          </span>
          <span v-show="!notificationStore.notificationUnreadCountIsLoading">
            {{ ` (${notificationStore.notificationUnreadCount})` }}
          </span>
        </div>
        <div
          class="flex-row-union align-center"
        >
          <CheckboxQmulus
            v-model="showOnlyUnreadNotification"
            :disabled="notificationStore.notificationUnreadCountIsLoading"
            :label="i18n.global.t(`${I18N_PREFIX}.showOnlyUnread`)"
          />
          <SemanticButton
            variant="optionMenu"
            @click="overflowMenu?.toggle"
          />
          <PrmMenu
            ref="overflowMenu"
            :model="overflowMenuItemList"
            :popup="true"
          />
        </div>
      </div>
      <div
        class="layout-item"
        style="
          max-height: 38rem;
          overflow: auto;
"
      >
        <PrmSkeleton v-if="isLoading" />
        <template v-else>
          <ItemNotification
            v-for="notification in notificationList?.data.items"
            :key="notification.notificationId"
            :notification="notification"
            @close="overlayPanel!.hide();"
          />
        </template>
      </div>
      <div
        style="height: 5rem; background-color: var(--surface-1); padding: var(--gap); gap: 0;"
        class="flex-row justify-end align-center w-full"
      >
        <router-link
          :to="{
            name: ERouteName.NOTIFICATION,
          }"
        >
          <QmulusButton
            :label="i18n.global.t(`${I18N_PREFIX}.seeAll`)"
            @click="overlayPanel!.hide();"
          />
        </router-link>
      </div>
    </div>
  </PrmOverlayPanel>
</template>

<script setup lang="ts">
import PrmMenu from '@NitrexGroup/primevue/menu';
import PrmOverlayPanel from '@NitrexGroup/primevue/overlaypanel';
import PrmSkeleton from '@NitrexGroup/primevue/skeleton';
import {
  i18n,
} from '@i18n';
import QmulusButton from '@qmulus/ui/components/button/qmulus-button.vue';
import SemanticButton from '@qmulus/ui/components/button/semantic-button.vue';
import CheckboxQmulus from '@qmulus/ui/components/checkbox-qmulus/checkbox-qmulus.vue';
import {
  ref,
  shallowRef,
  watch,
} from 'vue';

import NotificationUnreadIcon from '@/assets/icon/notification-unread.svg?component';
import ItemNotification from '@/components/item-notification/item-notification.vue';
import {
  useAxiosRequest,
} from '@/composition/use-axios-request';
import {
  getInAppNotifications,
  markAllRead,
} from '@/generated/qmulus/axios/core.ts';
import {
  ERouteName,
} from '@/router/route-name.ts';
import {
  useNotificationStore,
} from '@/store/pinia/notification.ts';

const I18N_PREFIX = 'components/overlay-panel-notification/overlay-panel-notification';

const notificationStore = useNotificationStore();
notificationStore.loadNotificationUnreadCount();

const showOnlyUnreadNotification = shallowRef(false);

const {
  data: notificationList,
  isLoading,
  execute,
} = useAxiosRequest(() => getInAppNotifications(
  {
    query: {
      page: 1,
      pageSize: 10,
      unseenOnly: showOnlyUnreadNotification.value,
    },
  },
), {
  shouldBeAborted: true,
});

watch(
  showOnlyUnreadNotification,
  execute,
  {
    immediate: true,
    deep: true,
  },
);

const overlayPanel = shallowRef<InstanceType<typeof PrmOverlayPanel>>();
const overflowMenu = shallowRef<InstanceType<typeof PrmMenu>>();
const overflowMenuItemList = ref([
  {
    label: i18n.global.t(`${I18N_PREFIX}.markAllAsRead`),
    command: () => markAllRead()
      .then(() => {
        execute();
        notificationStore.loadNotificationUnreadCount(true);
      }),
  },
]);
</script>
